const baseRoute = 'risk-manager/:moduleBridgeHex/';
export default {
  // user_module_inecoRiskManager_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //   },
  // },
  user_module_inecoRiskManager_risk_list: {
    path: `${baseRoute}risk/list/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_inecoRiskManager_risk_home: {
    path: `${baseRoute}risk/home/:riskID/`,
    parameters: {
      moduleBridgeHex: undefined,
      riskID: 0,
    },
  },
  user_module_inecoRiskManager_risk_add: {
    path: `${baseRoute}risk/add/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_inecoRiskManager_milestone_list: {
    path: `${baseRoute}milestone/list/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
};
